/**
 * Full-screen auth page wrapper with purple background, animated waves, and logo.
 *
 * Aliases: auth layout, auth page shell, login background
 */

import { Link } from "@tanstack/react-router";
import { motion } from "motion/react";
import type { ReactNode } from "react";

import { AuthBackground } from "~/components/auth/auth-background";
import ImageLogoWhite from "~/img/logo/dcm-logo-horizontal-white.png";

interface AuthShellProps {
  readonly children: ReactNode;
}

export function AuthShell({ children }: AuthShellProps) {
  return (
    <div className="relative flex min-h-screen w-full flex-col items-center justify-center">
      <AuthBackground />

      <div className="relative z-10 flex w-full flex-col items-center gap-8 px-4">
        <Link to="/">
          <motion.img
            src={ImageLogoWhite}
            alt="Dream Coach Match"
            className="w-[180px]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          />
        </Link>

        {children}
      </div>
    </div>
  );
}
